import { render, staticRenderFns } from "./ModalPupop.vue?vue&type=template&id=0b134f23&scoped=true&"
import script from "./ModalPupop.vue?vue&type=script&lang=js&"
export * from "./ModalPupop.vue?vue&type=script&lang=js&"
import style0 from "./ModalPupop.vue?vue&type=style&index=0&id=0b134f23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b134f23",
  null
  
)

export default component.exports